export default __webpack_public_path__ + "static/media/demo-cartes.cb0b39ce.mp4";